import { responseApi } from "use-hook-api"


const uid = process.env.NEXT_PUBLIC_UID

const dispatchURL = process.env.NEXT_PUBLIC_DISPATCH_URL
export const checkAppointment = (data) => {
    return responseApi(`${dispatchURL}/public/api/appointment/check/`, 'post', data, { uid })
}


export const getBookingList = () => {
    return responseApi(`${dispatchURL}/public/api/appointment/booked/`, 'get', null, { uid })
}

export const getTimesAvailable = () => {
    return responseApi(`${dispatchURL}/public/api/appointment/timing/`, 'get', null, { uid })
}
export const getBreaks = () => {
    return responseApi(`${dispatchURL}/public/api/appointment/break/`, 'get', null, { uid })
}
export const NewBookAppointment = (data) => {
    return responseApi(`${dispatchURL}/public/api/appointment/`, 'post', data, { uid })
}
export const GetLicenisingListApi = () => {
    return responseApi(`${dispatchURL}/public/api/appointment/licence-council/`, 'get', null, { uid })
}